<template>
  <h1 class="animated-title" :class="{'animated-title--animated': animated}">
    <span>P</span>
    <span>a</span>
    <span>i</span>
    <span>r</span>
    <span>s</span>
  </h1>
</template>

<script>
  export default {
    name: 'AnimatedTitle',
    props: {
      animated: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../config/styles/settings";
  @import "../../config/styles/util";

  $active-size-button-scale: 1.25;

  .animated-title {
    margin: 0;
    text-align: center;
    font-size: inherit;
    font-weight: normal;
    color: mix($purple-500, $blue-500);
    text-shadow: 1px 1px 1px $blue-300;
  }

  .animated-title.animated-title--animated {
    color: $blue-500;
  }

  .animated-title.animated-title--animated span {
    animation-name: color-spin;
    animation-duration: 2s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  @for $i from 1 through 5 {
    .animated-title.animated-title--animated span:nth-child(#{$i}) {
      animation-delay: #{220 * $i}ms;
    }
  }

  @keyframes color-spin {
    from {
      color: $blue-500;
    }
    to {
      color: $purple-500;
    }
  }
</style>
